import { FC, useEffect, useState } from "react";
import { useSeller } from "../../hooks/useSeller";
import api from "../../services/api";
import { error } from "console";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { Menu } from "../../components/Menu";
import styles from "./styles.module.css";
import { SellerCalogsItem } from "../../components/SellerCatalogItem/sellerCatalogItem";

export interface Catalogs {
  id: number;
  pluginspaceId: number;
  userId: number;
  catalog: string;
  status: number;
  imgCatalog: null;
  dateStart: string;
  dateEnd: string;
  created: string;
  deleted: null;
  order: number;
  updated: string;
  sellerId: number;
  linkCatalog: string;
  sellerCatalog: boolean;
  products: Product[];
}

interface Product {
  id: string;
  name: string;
  description: string;
  technicalSpecification: null | string;
  order: null | number;
  code: string;
  classificationId: string;
  userId: number;
  pluginspaceId: number;
  created: string;
  updated: string;
  deleted: null;
  measurementUnitId: string;
  parent: null | string;
  markId: string;
  type: string;
  status: boolean;
  typeFractional: null;
  quantityFractional: null;
  sellAsFractional: boolean;
  showFractionalPrice: boolean;
  showFractionalDescription: boolean;
  initialHour: null;
  finalHour: null;
  images?: Image;
}

interface Image {
  id: number;
  productId: number;
  pluginspaceId: number;
  path: string;
  imgsuffix: string;
  order: number;
  typeimg: string;
  created: string;
  updated: string;
  deleted: null;
}

const SellerCalogs: FC<any> = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [catalogs, setCatalogs] = useState<Catalogs[]>([]);
  const { getTokenSellertoRequest, sellerUser } = useSeller();
  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loadingHeader, setLoadingHeader] = useState(true);

  async function getCatalogs() {
    try {
      setLoading(true);
      if (sellerUser) {
        const newCatalogs = await api
          .post(
            "/api/catalog/filter",
            {
              sellerId: sellerUser.id,
            },
            {
              headers: {
                Authorization: `Bearer ${await getTokenSellertoRequest()}`,
              },
            }
          )
          .then((response) => {
            const data = response.data.data;
            const statusNewCatalogs = data.filter((catalog: any) => {
              const isStatusOk = catalog.status;
              const isDateValid = new Date() <= new Date(catalog.dateEnd);
              return isStatusOk && isDateValid;
            });
            return statusNewCatalogs;
          })
          .catch((error) => {
            console.log(error);
            return [];
          });

        setCatalogs(newCatalogs);
      } else {
        setCatalogs([]);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  }
  async function getConfig() {
    setLoadingHeader(true);
    setConfig(await getAppConfig());
    setLoadingHeader(false);
  }

  useEffect(() => {
    getConfig();
    if (sellerUser) getCatalogs();
  }, [sellerUser, sellerUser?.id]);

  return (
    <div className={styles["search-order"]}>
      <div className={styles["content-search-order"]}>
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <div className={styles["title-search"]}>
              <h2>Meus Catálogos</h2>
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => navigate(-1)}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.978551 2.21657L6.957 8.2395L0.978551 14.2624L2.97137 16.2701L8.94981 10.2471L14.9283 16.2701L16.9211 14.2624L10.9426 8.2395L16.9211 2.21657L14.9283 0.208931L8.94981 6.23186L2.97137 0.208931L0.978551 2.21657Z"
                  fill="#636363"
                />
              </svg>
            </div>
            <div className={styles["search-body"]}>
              <div className={styles["orders-finded"]}>
                {catalogs.length > 0 ? (
                  <>
                    {catalogs.map((catalog) => (
                      <SellerCalogsItem catalog={catalog} />
                    ))}
                  </>
                ) : (
                  <>
                    <h4>Não há catalogos vinculados ao seu usuário</h4>
                  </>
                )}
              </div>
            </div>
          </>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="order"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
      </div>
    </div>
  );
};

export { SellerCalogs };
